import styled from 'styled-components';

const IconWrapper = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: end;
`;

export default IconWrapper;
